import React from "react";

interface PageContentProps {
  children: React.ReactNode;
  maxWidth?: "sm" | "md" | "lg" | "xl" | "2xl" | "3xl" | "4xl" | "5xl" | "6xl" | "full";
  className?: string;
}

const maxWidthClasses = {
  sm: "max-w-sm",
  md: "max-w-md",
  lg: "max-w-lg",
  xl: "max-w-xl",
  "2xl": "max-w-2xl",
  "3xl": "max-w-3xl",
  "4xl": "max-w-4xl",
  "5xl": "max-w-5xl",
  "6xl": "max-w-6xl",
  full: "max-w-full",
};

/**
 * A content wrapper component for page content with consistent padding and max-width.
 */
export function PageContent({
  children,
  maxWidth = "5xl",
  className = "",
}: PageContentProps) {
  const maxWidthClass = maxWidthClasses[maxWidth];
  return (
    <div className={`flex-1 p-6 mt-12 ${className}`}>
      <div className={`container mx-auto ${maxWidthClass}`}>{children}</div>
    </div>
  );
}

